<template>
  <div class="attribute"
    :class="['color--' + getColor, { isActive: (currentlySelected === true) }]"
    @click="clicked()"
  >
    {{ attr.name }} <helptooltip :followMouse="false" v-if="tooltip !== false" class="attribute__help" :link="link" :description="tooltip"></helptooltip>
  </div><!-- /. attribute -->
</template>

<script>
import helptooltip from './../../misc/HelpTooltip.vue'

export default {
  name: 'attribute',
  components: { helptooltip },
  props: {
    attr: {
      type: Object,
      required: true
    },
    tooltip: {
      default: false
    },
    link: {
      default: false
    },
    color: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currentlySelected: false
    }
  },
  watch: {
    selected () {
      this.currentlySelected = this.selected
    }
  },
  computed: {
    getColor () {
      if (this.selected) {
        return this.color
      } else {
        return 'gray'
      }
    }
  },
  created () {
    this.currentlySelected = this.selected
  },
  methods: {
    clicked () {
      this.$emit('selected', this.currentlySelected)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';

  .attribute{
    cursor: pointer;
    font-weight: 500;
    margin: 0;
    position: relative;

    &:not(.isActive),
    &:not(.isActive):before {
      color: $gray-darkest;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/navigation/AttributesNavigation/Attribute.vue